export default __webpack_public_path__ + "static/media/p2023-43.c0086661.jpeg";